var paragraph_default = {
  "fontElementMap": "tuCxE",
  "elementSpacing": "jf0du",
  "text": "V8Y1u jf0du",
  "child": "_7-2Wt"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
